import { createSelector } from '@reduxjs/toolkit'

import { initialState } from '.'
import { RootState } from 'types'

const selectDomain = (state: RootState) =>
  typeof state !== 'undefined' ? state['animation'] || initialState : initialState

export const selectPosition = createSelector([selectDomain], (state) => state.position)
